import type * as PI from 'interfaces/project';
import _ from 'underscore';

interface ResolveThemePageStateModelOptions {
	allPages: PI.PageStateModel[];
	offset: number;
	pageIndex: number;
}

export function resolveThemePageStateModel(options: ResolveThemePageStateModelOptions): PI.PageStateModel {
	const {
		allPages,
		offset,
		pageIndex,
	} = options;
	const pageStateModel = _.findWhere(
		allPages,
		{
			serialnumber: pageIndex,
		},
	);

	if (pageStateModel) {
		return pageStateModel;
	}

	const sortedPageStates = _.sortBy(
		allPages,
		'serialnumber',
	);

	if (!sortedPageStates.length) {
		throw new Error('Could not find theme page state model: no page states available');
	}

	const repeatPageStates = sortedPageStates.filter((sortedPageStateModel) => (
		Boolean(sortedPageStateModel.repeat)
	));

	if (!repeatPageStates.length) {
		const lastPageStateModel = sortedPageStates[sortedPageStates.length - 1];

		if (pageIndex > lastPageStateModel.serialnumber) {
			return lastPageStateModel;
		}

		throw new Error(`Could not find theme page state model for page index ${pageIndex}`);
	}

	const nr = offset - (sortedPageStates.length - repeatPageStates.length);
	const modulus = (nr + repeatPageStates.length) % repeatPageStates.length;
	const repeatPageStateModel = repeatPageStates[modulus];

	if (!repeatPageStateModel) {
		throw new Error(`Could not find repeat theme page state model for page index ${pageIndex}`);
	}

	return repeatPageStateModel;
}
